module.exports = __webpack_public_path__ + "static/media/ehealth-bg2-preview.c3249f44.jpg";